(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const headerWrapper = document.querySelector('.header-wrapper');
    const header = document.querySelector('.section-header');
    const announcementBar = document.querySelector('.announcement-bar');
    let currentScrollTop = 0;
    let headerBounds = {};
    let isScrolling;

    function setHeaderHeight() {
      if (!header) return;
      document.documentElement.style.setProperty('--header-height', `${header.offsetHeight}px`);
    }

    function setAnnouncementBarHeight() {
      if (announcementBar) {
        const height = announcementBar.offsetHeight;
        document.documentElement.style.setProperty('--announcement-bar-height', `${height}px`);
      } else {
        document.documentElement.style.setProperty('--announcement-bar-height', '0px');
      }
    }

    function createObserver() {
      let observer = new IntersectionObserver((entries) => {
        headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(header);
    }

    function updateHeaderState(scrollTop) {
      // Handle transparent header on home page
      if (headerWrapper && window.location.pathname === '/') {
        if (scrollTop > 50) {
          headerWrapper.classList.add('scrolled');
        } else {
          headerWrapper.classList.remove('scrolled');
        }
      }

      // Handle sticky behavior for non-home pages
      if (window.location.pathname !== '/') {
        if (scrollTop > headerBounds.bottom) {
          header.classList.add('scrolled-past-header');
          header.classList.add('shopify-section-header-sticky');
        } else {
          header.classList.remove('scrolled-past-header');
          header.classList.remove('shopify-section-header-sticky');
        }
      }
    }

    function onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      // Clear any pending scroll timeout
      if (isScrolling) {
        window.clearTimeout(isScrolling);
      }

      // Update header state immediately
      updateHeaderState(scrollTop);

      // Store current scroll position
      currentScrollTop = scrollTop;

      // Set a timeout to handle any final scroll state
      isScrolling = setTimeout(() => {
        updateHeaderState(scrollTop);
      }, 100);
    }

    // Initialize
    setAnnouncementBarHeight();
    setHeaderHeight();
    createObserver();

    // Add event listeners
    window.addEventListener('scroll', onScroll, { passive: true });
    window.matchMedia('(max-width: 990px)').addEventListener('change', () => {
      setHeaderHeight();
      setAnnouncementBarHeight();
    });
    window.addEventListener('resize', setAnnouncementBarHeight);

    // Initialize header state
    updateHeaderState(window.scrollY);
  });

  } catch(e) { console.error(e); }
})();
})();
